import { isEmpty } from 'lodash-es'
import { createSelector } from 'reselect'

import { isAvailableFeatureSelector } from 'features/billing'

import { STATE_CONFIGURED, STATE_ENFORCED, STATE_TESTED } from './constants'

export const isLoadingSelector = (state) => state.organizationSettings.samlSsoSettings.isLoading

export const samlSettingsSelector = (state) => state.organizationSettings.samlSsoSettings.samlSettings

export const errorsSelector = (state) => state.organizationSettings.samlSsoSettings.errors

const deleteDialogSelector = (state) => state.organizationSettings.samlSsoSettings.deleteDialog

const testSamlSelector = (state) => state.organizationSettings.samlSsoSettings.testSamlSettings

const ssoStateSelector = createSelector(
  samlSettingsSelector,
  (settings) => settings && settings.state
)

export const ssoTestedSelector = createSelector(
  ssoStateSelector,
  (state) => [STATE_TESTED, STATE_ENFORCED].includes(state)
)

export const ssoConfiguredSelector = createSelector(
  ssoStateSelector,
  (state) => [STATE_CONFIGURED, STATE_TESTED, STATE_ENFORCED].includes(state)
)

export const ssoEnforcedSelector = createSelector(
  ssoStateSelector,
  (state) => STATE_ENFORCED === state
)

export const testSamlSettingsSelector = createSelector(
  testSamlSelector,
  ({ settings }) => settings
)
export const testSamlSessionSettingsSelector = createSelector(
  testSamlSelector,
  ({ sessionSettings }) => sessionSettings
)

export const testSamlSessionErrorsSelector = createSelector(
  testSamlSelector,
  ({ errors }) => errors
)

export const currentTestStepSelector = createSelector(
  testSamlSelector,
  ({ step }) => step
)

export const isSamlTestModalOpenSelector = createSelector(
  testSamlSelector,
  ({ isModalOpen }) => isModalOpen
)

export const isTestSamlSettingsLoadingSelector = createSelector(
  testSamlSelector,
  ({ isLoading }) => isLoading
)

export const isNewSelector = createSelector(
  samlSettingsSelector,
  isEmpty
)


export const currentStepSelector = (state) => state.organizationSettings.samlSsoSettings.currentStep

export const isSamlFeatureEnabledSelector = (state) => isAvailableFeatureSelector(state, { featureKey: 'saml_single_sign_on' })

export const isDeleteDialogOpenSelector = createSelector(
  deleteDialogSelector,
  ({ isDialogOpen }) => isDialogOpen
)

export const isDeleteDialogOpenLoadingSelector = createSelector(
  deleteDialogSelector,
  ({ isLoading }) => isLoading
)
